// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__bzDAb","dashboardContent":"Dashboard_dashboardContent__iZ+Gl","outletContainer":"Dashboard_outletContainer__ov8+1"};